export default __webpack_public_path__ + "static/media/sec2ilu.6a9bb782.svg";